import MapRepository from "@domain/repositories/MapRepository";
import UseCase from "@domain/UseCase";
import { Map } from "@domain/models/Map";

type Input = {
  mapId: Map["id"];
  data: Partial<Map>;
};

type Output = Promise<Map>;

export class UpdateMapUseCase implements UseCase<Input, Output> {
  constructor(private readonly mapRepository: MapRepository) {}

  execute({ mapId, data }: Input) {
    return this.mapRepository.update(mapId, data);
  }
}
